import React from 'react';
import { Toaster } from 'react-hot-toast';

import { datadogRum } from '@datadog/browser-rum';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AgCharts } from 'ag-charts-enterprise';
import { useRecoilValue } from 'recoil';

import AutoLogout from 'components/AutoLogout/AutoLogout';
import ErrorBoundary from 'components/shared/Error/Boundary';
import 'components/shared/Forms/Custom/Register';

import AutoUpdate from './components/AutoUpdate/AutoUpdate';
import Utility from './components/Utility';
import state from './components/state';
import { Routes } from './routes/Routes';

import './styles/main.scss';

AgCharts.setLicenseKey(process.env.REACT_AG_GRID_KEY);

const queryClient = new QueryClient();

const App = () => {
  if (
    (process.env.ENV === 'development' || process.env.ENV === 'production') &&
    window.__APP_VERSION__
  ) {
    datadogRum.init({
      applicationId: 'cb6d45cb-947a-48d9-9bb8-d1d15a109db0',
      clientToken: 'pubbc5c7e531a26bd07f2c4b08e6a90bc77',
      site: 'datadoghq.com',
      service: 'myriad-health',
      env: process.env.ENV,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      version: window.__APP_VERSION__,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask',
      traceContextInjection: 'all',
      allowedTracingUrls: [(url) => url.startsWith(process.env.REACT_APP_BASE_API_URL)],
      traceSampleRate: 100,
      beforeSend: (event, context) => {
        try {
          if (event.type !== 'resource' || event.resource.type !== 'xhr') {
            return true;
          }
          // Capture response headers if available
          const xhr = context?.xhr;
          if (!xhr) {
            return true;
          }
          event.context.responseHeaders = Object.fromEntries(
            xhr
              .getAllResponseHeaders()
              .split('\r\n')
              .filter((header) => header)
              .map((header) => header.split(': ').map((item) => item.trim()))
          );
        } catch (e) {
          console.log(e);
        }
        return true;
      }
    });
  }

  const hasBeenAuthChecked = useRecoilValue(state.hasBeenAuthChecked);

  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <Utility />
        {/*<Socket />*/}
        {hasBeenAuthChecked.checked && <Routes />}
        <Toaster position="bottom-right" />
        {process.env.ENV !== 'local' && <AutoLogout />}
        <AutoUpdate />
      </ErrorBoundary>
      {process.env.NODE_ENV === 'development' && <ReactQueryDevtools />}
    </QueryClientProvider>
  );
};

export default App;
export { queryClient };
